// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1GQLZ","info":"Note_info__2aCjy","note":"Note_note__nXRBS","actions":"Note_actions__3nqrE"};